import { Box, Stack } from '@mui/material';
import { Cell, Text } from '@telegram-apps/telegram-ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getColor } from '../../helpers/color';
import { CommonIcon } from './CommonIcon';
import { LiquidGlassRowCard } from './LiquidGlassRowCard';

interface IconPickerProps {
  selectedIcon: string;
  selectedIconColor: string;
  onClick: () => void;
}

export const IconPicker: FC<IconPickerProps> = ({ selectedIcon, selectedIconColor, onClick }) => {
  const { t } = useTranslation();

  return (
    <LiquidGlassRowCard>
      <Cell
        onClick={onClick}
        after={
          <Box sx={{
            width: 30,
            height: 30,
            borderRadius: 2,
            background: getColor(selectedIconColor),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <CommonIcon
              icon={selectedIcon}
              type="filled"
              size={24}
              color="var(--tg-theme-text-color)"
            />
          </Box>
        }
      >
        <Stack direction="column" gap={0.1}>
          <Text weight="2">{t('picker.icon')}</Text>
          <Text style={{ fontSize: '12px', color: 'var(--tgui--hint_color)' }}>
            {t('picker.chooseIcon')}
          </Text>
        </Stack>
      </Cell>
    </LiquidGlassRowCard>
  );
};
